import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import QuoteDialog from "@/components/QuoteDialog";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [categories, setCategories] = useState([]);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  const openQuote = useCallback((data = {}) => {
    setPrefill(data);
    setQuoteOpen(true);
  }, []);

  return (
    <SiteContext.Provider value={{ config, categories, openQuote }}>
      {children}
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} prefill={prefill} categories={categories} />
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
